window.dataLang = {
  "cs": {
    "emptyTable": "Tabulka neobsahuje žádná data",
    "info": "Zobrazuji _START_ až _END_ z celkem _TOTAL_ záznamů",
    "infoEmpty": "Zobrazuji 0 až 0 z 0 záznamů",
    "infoFiltered": "(filtrováno z celkem _MAX_ záznamů)",
    "loadingRecords": "Načítám...",
    "zeroRecords": "Žádné záznamy nebyly nalezeny",
    "paginate": {
      "first": "První",
      "last": "Poslední",
      "next": "Další",
      "previous": "Předchozí"
    },
    "searchBuilder": {
      "add": "Přidat podmínku",
      "clearAll": "Smazat vše",
      "condition": "Podmínka",
      "conditions": {
        "date": {
          "after": "po",
          "before": "před",
          "between": "mezi",
          "empty": "prázdné",
          "equals": "rovno",
          "not": "není",
          "notBetween": "není mezi",
          "notEmpty": "není prázdné"
        },
        "number": {
          "between": "mezi",
          "empty": "prázdné",
          "equals": "rovno",
          "gt": "větší",
          "gte": "rovno a větší",
          "lt": "menší",
          "lte": "rovno a menší",
          "not": "není",
          "notBetween": "není mezi",
          "notEmpty": "není prázdné"
        },
        "string": {
          "contains": "obsahuje",
          "empty": "prázdné",
          "endsWith": "končí na",
          "equals": "rovno",
          "not": "není",
          "notEmpty": "není prázdné",
          "startsWith": "začíná na"
        },
        "array": {
          "equals": "rovno",
          "empty": "prázdné",
          "contains": "obsahuje",
          "not": "není",
          "notEmpty": "není prázdné",
          "without": "neobsahuje"
        }
      },
      "data": "Sloupec",
      "logicAnd": "A",
      "logicOr": "NEBO",
      "title": {
        "0": "Rozšířený filtr",
        "_": "Rozšířený filtr (%d)"
      },
      "value": "Hodnota",
      "button": {
        "0": "Rozšířený filtr",
        "_": "Rozšířený filtr (%d)"
      },
      "deleteTitle": "Smazat filtrovací pravidlo"
    },
    "select": {
      "1": "Vybrán %d záznam",
      "2": "Vybrány %d záznamy",
      "_": "Vybráno %d záznamů",
      "cells": {
        "1": "Vybrán 1 záznam",
        "_": "Vybráno %d záznamů"
      },
      "columns": {
        "1": "Vybrán 1 sloupec",
        "_": "Vybráno %d sloupců"
      }
    },
    "autoFill": {
      "cancel": "Zrušit",
      "fill": "Vyplň všechny buňky textem <i>%d<i><\/i><\/i>",
      "fillHorizontal": "Vyplň všechny buňky horizontálně",
      "fillVertical": "Vyplň všechny buňky vertikálně"
    },
    "buttons": {
      "collection": "Kolekce <span class=\"ui-button-icon-primary ui-icon ui-icon-triangle-1-s\"><\/span>",
      "copy": "Kopírovat",
      "copySuccess": {
        "1": "Skopírován 1 řádek do schránky",
        "_": "SKopírováno %d řádků do schránky"
      },
      "copyTitle": "Kopírovat do schránky",
      "csv": "CSV",
      "excel": "Excel",
      "pageLength": {
        "-1": "Zobrazit všechny řádky",
        "1": "Zobrazit 1 řádek",
        "_": "Zobrazit %d řádků"
      },
      "pdf": "PDF",
      "print": "Tisknout",
      "colvis": "Viditelnost sloupců",
      "colvisRestore": "Resetovat sloupce",
      "copyKeys": "Zmáčkněte ctrl or u2318 + C pro zkopírování dat.  Pro zrušení klikněte na tuto zprávu nebo zmáčkněte esc.."
    },
    "searchPanes": {
      "clearMessage": "Smazat vše",
      "collapse": {
        "0": "Vyhledávací Panely",
        "_": "Vyhledávací Panely (%d)"
      },
      "count": "{total}",
      "countFiltered": "{shown} ({total})",
      "emptyPanes": "Žádné Vyhledávací Panely",
      "loadMessage": "Načítám Vyhledávací Panely",
      "title": "Aktivních filtrů - %d"
    },
    "aria": {
      "sortAscending": "Aktivujte pro seřazení vzestupně",
      "sortDescending": "Aktivujte pro seřazení sestupně"
    },
    "infoThousands": ",",
    "lengthMenu": "Zobrazit _MENU_ výsledků",
    "processing": "Zpracovávání...",
    "search": "Vyhledávání:",
    "thousands": ",",
    "datetime": {
      "previous": "Předchozí",
      "next": "Další",
      "hours": "Hodiny",
      "minutes": "Minuty",
      "seconds": "Vteřiny",
      "unknown": "-",
      "amPm": [
        "Dopoledne",
        "Odpoledne"
      ]
    },
    "editor": {
      "close": "Zavřít",
      "create": {
        "button": "Nový",
        "title": "Nový záznam",
        "submit": "Vytvořit"
      },
      "edit": {
        "button": "Změnit",
        "title": "Změnit záznam"
      }
    }
  },
  "en": {
    "emptyTable": "No data available in table",
    "info": "Showing _START_ to _END_ of _TOTAL_ entries",
    "infoEmpty": "Showing 0 to 0 of 0 entries",
    "infoFiltered": "(filtered from _MAX_ total entries)",
    "infoThousands": ",",
    "lengthMenu": "Show _MENU_ entries",
    "loadingRecords": "Loading...",
    "processing": "Processing...",
    "search": "Search:",
    "zeroRecords": "No matching records found",
    "thousands": ",",
    "paginate": {
      "first": "First",
      "last": "Last",
      "next": "Next",
      "previous": "Previous"
    },
    "aria": {
      "sortAscending": ": activate to sort column ascending",
      "sortDescending": ": activate to sort column descending"
    },
    "autoFill": {
      "cancel": "Cancel",
      "fill": "Fill all cells with <i>%d<\/i>",
      "fillHorizontal": "Fill cells horizontally",
      "fillVertical": "Fill cells vertically"
    },
    "buttons": {
      "collection": "Collection <span class='ui-button-icon-primary ui-icon ui-icon-triangle-1-s'\/>",
      "colvis": "Column Visibility",
      "colvisRestore": "Restore visibility",
      "copy": "Copy",
      "copyKeys": "Press ctrl or u2318 + C to copy the table data to your system clipboard.<br><br>To cancel, click this message or press escape.",
      "copySuccess": {
        "1": "Copied 1 row to clipboard",
        "_": "Copied %d rows to clipboard"
      },
      "copyTitle": "Copy to Clipboard",
      "csv": "CSV",
      "excel": "Excel",
      "pageLength": {
        "-1": "Show all rows",
        "1": "Show 1 row",
        "_": "Show %d rows"
      },
      "pdf": "PDF",
      "print": "Print"
    },
    "searchBuilder": {
      "add": "Add Condition",
      "button": {
        "0": "Search Builder",
        "_": "Search Builder (%d)"
      },
      "clearAll": "Clear All",
      "condition": "Condition",
      "conditions": {
        "date": {
          "after": "After",
          "before": "Before",
          "between": "Between",
          "empty": "Empty",
          "equals": "Equals",
          "not": "Not",
          "notBetween": "Not Between",
          "notEmpty": "Not Empty"
        },
        "number": {
          "between": "Between",
          "empty": "Empty",
          "equals": "Equals",
          "gt": "Greater Than",
          "gte": "Greater Than Equal To",
          "lt": "Less Than",
          "lte": "Less Than Equal To",
          "not": "Not",
          "notBetween": "Not Between",
          "notEmpty": "Not Empty"
        },
        "string": {
          "contains": "Contains",
          "empty": "Empty",
          "endsWith": "Ends With",
          "equals": "Equals",
          "not": "Not",
          "notEmpty": "Not Empty",
          "startsWith": "Starts With"
        },
        "array": {
          "without": "Without",
          "notEmpty": "Not Empty",
          "not": "Not",
          "contains": "Contains",
          "empty": "Empty",
          "equals": "Equals"
        }
      },
      "data": "Data",
      "deleteTitle": "Delete filtering rule",
      "leftTitle": "Outdent Criteria",
      "logicAnd": "And",
      "logicOr": "Or",
      "rightTitle": "Indent Criteria",
      "title": {
        "0": "Search Builder",
        "_": "Search Builder (%d)"
      },
      "value": "Value"
    },
    "searchPanes": {
      "clearMessage": "Clear All",
      "collapse": {
        "0": "SearchPanes",
        "_": "SearchPanes (%d)"
      },
      "count": "{total}",
      "countFiltered": "{shown} ({total})",
      "emptyPanes": "No SearchPanes",
      "loadMessage": "Loading SearchPanes",
      "title": "Filters Active - %d"
    },
    "select": {
      "1": "%d row selected",
      "_": "%d rows selected",
      "cells": {
        "1": "1 cell selected",
        "_": "%d cells selected"
      },
      "columns": {
        "1": "1 column selected",
        "_": "%d columns selected"
      }
    },
    "datetime": {
      "previous": "Previous",
      "next": "Next",
      "hours": "Hour",
      "minutes": "Minute",
      "seconds": "Second",
      "unknown": "-",
      "amPm": [
        "am",
        "pm"
      ]
    },
    "editor": {
      "close": "Close",
      "create": {
        "button": "New",
        "title": "Create new entry",
        "submit": "Create"
      },
      "edit": {
        "button": "Edit",
        "title": "Edit Entry",
        "submit": "Update"
      },
      "remove": {
        "button": "Delete",
        "title": "Delete",
        "submit": "Delete",
        "confirm": {
          "_": "Are you sure you wish to delete %d rows?",
          "1": "Are you sure you wish to delete 1 row?"
        }
      },
      "error": {
        "system": "A system error has occurred (<a target=\"\\\" rel=\"nofollow\" href=\"\\\">More information<\/a>)."
      },
      "multi": {
        "title": "Multiple Values",
        "info": "The selected items contain different values for this input. To edit and set all items for this input to the same value, click or tap here, otherwise they will retain their individual values.",
        "restore": "Undo Changes",
        "noMulti": "This input can be edited individually, but not part of a group. "
      }
    }
  }
}
